import { LocationState } from "../context/LocationContext";
import {
  GET_ALL_LOCATIONS,
  SET_LOCATION_LOADING,
  UPDATE_LOCATIONS,
} from "../types/locations.type";

const LocationReducer = (state: LocationState, action: any) => {
  switch (action.type) {
    case SET_LOCATION_LOADING:
      return {
        ...state,
        loading: action.isLoading,
      };
    case UPDATE_LOCATIONS:
      return {
        ...state,
        location: action.payload,
      };
    case GET_ALL_LOCATIONS:
      return {
        ...state,
        locations: action.payload,
      };
    default:
      return state;
  }
};

export default LocationReducer;
